module.exports = __webpack_public_path__ + "static/img/banner-kegel.ebbf8a89.png";